import { useEffect, useLayoutEffect } from "react"
import isServer from "~/lib/isServer"

export function useIsomorphicLayoutEffect() {
  return isServer() ? useEffect : useLayoutEffect
}
